/** @format */
import React, { ComponentProps, FunctionComponent } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { Select as DeprecatedSelect } from '@toucan/client/shared/components/select';

type SelectProps = ComponentProps<typeof DeprecatedSelect>;

export { SelectSkeleton } from './skeleton';

/** This is a shim in order to make the Formik Select component compatible with react-hook-form */
export const Select: FunctionComponent<SelectProps> = (props) => {
    const { control } = useFormContext();

    const { field } = useController({
        name: props.name,
        control,
    });

    return (
        <DeprecatedSelect
            onChange={field.onChange}
            value={field.value}
            {...props}
        />
    );
};
